const nl = {
  // Algemeen
  app_name: 'Buurtlader',
  laden: 'Laden...',
  opslaan: 'Opslaan',
  annuleren: 'Annuleren',
  terug: 'Terug',
  verder: 'Verder',
  bevestigen: 'Bevestigen',
  verwijderen: 'Verwijderen',
  sluiten: 'Sluiten',
  fout: 'Er is iets misgegaan. Probeer opnieuw.',

  // Auth
  inloggen: 'Inloggen',
  uitloggen: 'Uitloggen',
  registreren: 'Registreren',
  email: 'E-mailadres',
  wachtwoord: 'Wachtwoord',
  naam: 'Volledige naam',
  email_placeholder: 'jouw@email.nl',
  wachtwoord_placeholder: '••••••••',
  naam_placeholder: 'Jan de Vries',
  geen_account: 'Nog geen account?',
  al_account: 'Al een account?',
  registreer_hier: 'Registreer hier',
  login_hier: 'Log hier in',
  rol_kiezen: 'Ik ben een',
  rijder: 'EV-rijder',
  eigenaar: 'Laadpaal eigenaar',
  beide: 'Beide',
  welkom_terug: 'Welkom terug',
  maak_account: 'Maak een account aan',
  auth_subtitle_login: 'Vind laadpalen bij jou in de buurt',
  auth_subtitle_register: 'Deel jouw laadpaal en verdien geld',

  // Kaart
  kaart: 'Kaart',
  zoeken: 'Zoeken',
  zoek_placeholder: 'Zoek op adres of postcode...',
  beschikbaar: 'Beschikbaar',
  bezet: 'Bezet',
  alle_laadpalen: 'Alle laadpalen',
  alleen_beschikbaar: 'Alleen beschikbaar',
  laadpalen_gevonden: 'laadpalen gevonden',
  geen_laadpalen: 'Geen laadpalen gevonden',
  laadpaal_toevoegen: 'Laadpaal toevoegen',

  // Laadpaal details
  boeken: 'Boeken',
  per_kwh: '/kWh',
  beoordelingen: 'beoordelingen',
  beschikbaarheid: 'Beschikbaarheid',
  nu_bezet: 'Nu bezet — probeer later opnieuw',

  // Laadpaal registreren
  laadpaal_registreren: 'Laadpaal registreren',
  laadpaal_registreren_subtitle: 'Deel jouw laadpaal en verdien geld',
  laadpaal_naam: 'Naam laadpaal',
  laadpaal_naam_placeholder: 'bijv. Mijn thuislader',
  adres: 'Adres',
  adres_placeholder: 'Straat en huisnummer',
  stad: 'Stad',
  stad_placeholder: 'Amsterdam',
  postcode: 'Postcode',
  postcode_placeholder: '1234AB',
  connector_type: 'Connector type',
  snelheid: 'Laadsnelheid',
  prijs: 'Prijs per kWh (€)',
  prijs_placeholder: '0.25',
  beschikbare_uren: 'Beschikbare uren',
  laadpaal_opslaan: 'Laadpaal opslaan',
  laadpaal_opgeslagen: 'Laadpaal succesvol opgeslagen! 🔌',

  // Beschikbaarheid
  maandag: 'Maandag',
  dinsdag: 'Dinsdag',
  woensdag: 'Woensdag',
  donderdag: 'Donderdag',
  vrijdag: 'Vrijdag',
  zaterdag: 'Zaterdag',
  zondag: 'Zondag',
  van: 'Van',
  tot: 'Tot',
  dag_toevoegen: 'Dag toevoegen',

  // Boekingen
  boekingen: 'Boekingen',
  mijn_boekingen: 'Mijn boekingen',
  geen_boekingen: 'Nog geen boekingen',
  geen_boekingen_sub: 'Vind een laadpaal op de kaart!',
  datum: 'Datum',
  starttijd: 'Starttijd',
  duur: 'Duur',
  bericht: 'Bericht aan eigenaar',
  bericht_placeholder: 'Optioneel: stel een vraag of geef meer info...',
  geschatte_kosten: 'Geschatte kosten',
  boeking_bevestigen: 'Boeking bevestigen',
  boeking_verzonden: 'Boeking verzonden! 🎉',
  boeking_geannuleerd: 'Boeking geannuleerd',

  // Boeking statussen
  in_behandeling: 'In behandeling',
  geaccepteerd: 'Geaccepteerd',
  geweigerd: 'Geweigerd',
  geannuleerd: 'Geannuleerd',
  niet_verschenen: 'Niet verschenen',

  // Eigenaar acties
  accepteren: 'Accepteren',
  weigeren: 'Weigeren',
  reactie_placeholder: 'Optioneel: voeg een bericht toe...',
  boeking_geaccepteerd: 'Boeking geaccepteerd ✅',
  boeking_geweigerd: 'Boeking geweigerd',
  verzoeken: 'Boekingsverzoeken',
  geen_verzoeken: 'Geen nieuwe verzoeken',

  // Mijn laadpalen
  mijn_laadpalen: 'Mijn laadpalen',
  geen_laadpalen_eigen: 'Nog geen laadpalen',
  geen_laadpalen_eigen_sub: 'Voeg jouw eerste laadpaal toe',
  laadpaal_toevoegen_btn: 'Laadpaal toevoegen',
  actief: 'Actief',
  inactief: 'Inactief',

  // Profiel
  profiel: 'Profiel',
  account: 'Account',
  uitloggen_bevestig: 'Weet je zeker dat je wilt uitloggen?',

  // Navigatie
  nav_kaart: 'Kaart',
  nav_boekingen: 'Boekingen',
  nav_laadpalen: 'Laadpalen',
  nav_profiel: 'Profiel',
}

export default nl